import Ngalawa from "@/assets/images/ngalawa.webp";
import Logo from "@/assets/images/zct-logo.jpg";
import LoginForm from "@/features/auth/forms/login-form";


const Login = () => {

    return (
        <div>
            <div className="flex flex-wrap lg:flex-nowrap">
                <section className="relative w-full lg:w-1/2 flex flex-col justify-end p-4 md:p-12 h-80 lg:h-screen bg-gradient-to-t from-secondary to-secondary-100 overflow-hidden">
                     <img 
                        src={Ngalawa}
                        alt="ngalawa"
                        className="absolute inset-0 w-full lg:h-screen origin-bottom object-cover mix-blend-multiply"
                    />
                    <div className="relative z-10 text-white bg-white/20 backdrop-blur-sm rounded-xl p-4 md:p-8">
                        <h4 className="text-xl md:text-2xl xl:text-4xl font-semibold mb-2">
                            Welcome to Zanzibar official tourism residency licensing portal
                        </h4>
                        <p className="text-sm md:text-base font-light">
                            Facilitating secure, efficient, and transparent licensing and 
                            investment processes for individuals and businesses contributing 
                            to Zanzibar's vibrant tourism industry.
                        </p>
                    </div>
                </section>

                <section className="w-full lg:w-1/2 pt-8 md:pt-16 flex flex-col justify-between">
                    <div>
                        <div className="w-4/5 md:w-1/3 xl:w-2/5 space-y-2 mx-auto mb-8 md:mb-16">
                            <img 
                                src={Logo} 
                                alt="zct-logo"
                                className="size-16 xl:size-24 mx-auto mb-4"
                            />
                            <h4 className="text-center md:text-lg xl:text-xl text-primary font-semibold">
                                Zanzibar Commission for Tourism
                            </h4>
                        </div>

                        <div className="w-4/5 md:w-3/5 xl:w-1/2 mx-auto text-zinc-500 text-center">
                            <h4 className="text-lg xl:text-2xl text-secondary font-semibold mb-2">
                                Login
                            </h4>
                            <p className="text-sm lg:text-base text-secondary font-light mb-8">
                                Please enter your registered email and password below to sign in.
                            </p>

                            <LoginForm />
                        </div>

                    </div>

                    <div className="flex justify-between text-xs text-secondary p-4">
                        <p>
                            &copy; {new Date().getFullYear()} ZCT, All Right Reserved
                        </p>
                        <div className="flex items-center space-x-2">
                            <a href="" className="underline">Privacy Policy</a>
                            <div className="w-1.5 h-1.5 rounded-full bg-zinc-200"></div>
                            <a href="" className="underline">Terms & Conditions</a>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Login